// extracted by mini-css-extract-plugin
export default {"input":"FormikInputDate_input__h8QkI","input--empty":"FormikInputDate_input--empty__ntJSm"};